import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { DEFAULT_ZOOM_RANGE } from '../../../constants';
import * as styles from './ZoomButtons.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ZoomButtons = function ZoomButtons(_ref) {
  var control = _ref.control,
    map = _ref.map,
    _ref$zoomRange = _ref.zoomRange,
    zoomRange = _ref$zoomRange === void 0 ? DEFAULT_ZOOM_RANGE : _ref$zoomRange;
  var _React$useState = React.useState(map.getZoom()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    zoom = _React$useState2[0],
    setZoom = _React$useState2[1];
  var handleClick = React.useCallback(function (newZoom) {
    var type = control.type,
      onClick = control.onClick;
    if (onClick) {
      onClick({
        type: type
      });
    }
    map.setZoom(newZoom);
    setZoom(newZoom);
  }, [map, control]);
  var handleZoomIn = React.useCallback(function () {
    var newZoom = map.getZoom() + 1;
    handleClick(newZoom);
  }, [map, handleClick]);
  var handleZoomOut = React.useCallback(function () {
    var newZoom = map.getZoom() - 1;
    handleClick(newZoom);
  }, [map, handleClick]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['zoom-buttons'],
    children: [/*#__PURE__*/_jsx("button", {
      className: styles['zoom-plus'],
      onClick: handleZoomIn,
      disabled: zoomRange.max === zoom,
      children: /*#__PURE__*/_jsx("div", {
        className: styles['icon']
      })
    }), /*#__PURE__*/_jsx("button", {
      className: styles['zoom-minus'],
      onClick: handleZoomOut,
      disabled: zoomRange.min === zoom,
      children: /*#__PURE__*/_jsx("div", {
        className: styles['icon']
      })
    })]
  });
};